<template>
    <div class="question">
      <img src="../../../static/images/icon/ques.png" alt="" />
      <div class="main">
        <div class="ques">
          <h5>您的年龄是？</h5>
          <el-radio-group v-model="age">
            <el-radio-button label="1">50岁以上</el-radio-button>
            <el-radio-button label="2">50岁以下</el-radio-button>
          </el-radio-group>
        </div>
        <div class="ques">
          <h5>您想重点调理的方向是?</h5>
          <el-radio-group v-model="nurse">
            <el-radio-button label="1">慢性病</el-radio-button>
            <el-radio-button label="2">养生</el-radio-button>
            <el-radio-button label="3">其他</el-radio-button>
          </el-radio-group>
        </div>
        <div class="ques">
          <h5>您是否有听过其他中医课程？</h5>
          <el-radio-group v-model="course">
            <el-radio-button label="1">是</el-radio-button>
            <el-radio-button label="2">否</el-radio-button>
          </el-radio-group>
        </div>
  
        <div class="cbtn" @click="submit">
          <div class="text">下一步</div>
        </div>
      </div>
  
      <div class="mask" v-if="loading">
        <div class="bg-white">
          <i class="el-icon-loading"></i>
          <p>正在加载中...</p>
        </div>
      </div>
      <div class="mask" v-if="showWxRes">
        <div class="panel panel2">
          <div class="df">
            <div class="btn left" @click="rePay">未支付</div>
            <div class="btn right" @click="reWechat">已支付,添加老师</div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { getAgent } from "@/utils/index";
  
  export default {
    data() {
      return {
        age: "",
        nurse: "",
        course: "",
        loading: false,
        pathId: "",
        openType: "",
        produInfo: {},
        productId: "",
        userPhone: "",
        showWxRes: false,
        orderId:'',
        customerId:'',
        host_type:'',
        isForm:'',
        isQuestion:'',
        mediaProjectId:''
      };
    },
    created() {
      this.isForm=this.$route.query.isForm
      this.isQuestion=this.$route.query.isQuestion
      this.mediaProjectId=this.$route.query.mediaProjectId
      this.pathId = this.$route.query.pathId;
      this.openType = this.$route.query.type || "";
      this.produInfo = JSON.parse(sessionStorage.getItem('produInfo'));
      this.productId = this.$route.query.productId;
      this.userPhone = this.$route.query.userPhone || this.$store.state.userPhone;
      this.customerId= this.$route.query.customerId;
      this.host_type = this.$route.query.host_type
      console.log(this.productId, this.userPhone, this.produInfo, this.orderId,this.customerId);
    },
    methods: {
     submit() {
        if (!this.age) {
          this.$message({ message: "请选择您的年龄" });
          return false;
        }
        if (!this.course) {
          this.$message({ message: "请选择您的调理方向" });
          return false;
        }
        if (!this.nurse) {
          this.$message({ message: "请选择您是否听过其他课程" });
          return false;
        }
        if (!this.pathId) {
          this.loading = false;
          this.$message({ message: "投放id异常" });
          return false;
        }
        this.loading = false;
        this.commonPoint(
          this.pathId,
          this.$route.query.productId,
          "ecApplyNow",
          2
        );
  
        let params = {
          qsAge: this.age,
          qsIsohterCourse: this.course,
          qsConditionDirection: this.nurse,
          clickId: this.pathId,
          productId: this.$route.query.productId
        };
        axios({
          method: "POST",
          url: `${this.$single}/api/advert/launch/insetQsInfo`,
          data: params
        }).then(res => {
          if (res.data.code == 200) {
            this.getUserOrders()
            if (this.produInfo.productPrice == 0) {
              if (this.openType == "cust") {

              } else {
                this.getToken();
              }
            } 
          } else {
            this.$message({ message: res.data.msg });
          }
        });
      },
      custOpen() {
        axios({
          method: "POST",
          url: `${this.$single}/api/advert/launch/getWechatLinkFree`,
          params: {
            orderId: this.$route.query.orderId,
            productId: this.$route.query.productId,
            pathId: this.pathId
          }
        }).then(res => {
          if (res.data.code == 200) {
            let data = res.data.data;
            let path =
              data.link_url +
              "?customer_channel=" +
              data.orderId +
              "_H5" +
              "_" +
              this.$route.query.productId;
            this.openUrl(path);

          } else {
            this.$message({ message: res.data.message });
          }
        });
      },
      openUrl(path) {
        if (getAgent()) {
          window.open(path);
        } else {
          window.location.href = path;
        }
      },
      getToken() {
        axios
          .get(
            `${this.$siteURL}/wxapi/cgi-bin/token?grant_type=client_credential&appid=${this.$wechatAppid}&secret=${this.$wechatSecret}`
          )
          .then(res => {
            if (res.status == 200) {
              this.getScheme(res.data.access_token);
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      getScheme(token) {
        axios({
          method: "POST",
          url: `${this.$siteURL}/wxapi/wxa/generatescheme?access_token=${token}`,
          data: {
            jump_wxa: {
              query: "pathId=" + this.pathId
            }
          }
        }).then(res => {
          window.location.href = res.data.openlink;
          this.loading = false;
        });
      },
      getUserOrders() {
          axios({
          method: "POST",
          url: `${this.$single}/api/advert/launch/submitOrders`,
          data: {
            customerId: this.customerId,
            pathId: this.pathId,
            productId: this.productId,
            userPhone: this.userPhone,
            isForm:this.isForm,
            isQuestion:this.isQuestion,
            mediaProjectId:this.mediaProjectId
          }
        }).then(res => {
          if(res.data.data!=null){
            this.orderId=res.data.data.code
          }
          else{
            this.orderId=''
          } 
          if (res.data.code == 200) {
          if(this.produInfo.productPrice>0){
            if(this.host_type==1){
              let path = `${this.$siteURL}/pay/index?productId=${this.productId}&pathId=${this.pathId}&phone=${this.form.mobile}&orderId=${this.orderId}`
              window.location.href = path
            }
            else{
            this.wechatPay();
            }
          }
          else{
            this.wechatOpen(1,0)
          }
        
          } 
          else if(res.data.code == 1004){
             this.wechatOpen(1,0)
          }
          else {
            this.$message({ message: res.data.message })
          }

        });
       
      },
      rePay() {
        this.showWxRes = false;
        this.commonPoint(this.pathId, this.productId, "ecNonPayment", 0);
        clearInterval(this.wxPoll);
      },
      //支付弹窗-已支付
      reWechat() {
        this.wechatOpen(1, 1);
        this.commonPoint(this.pathId, this.productId, "ecNonPayment", 1);
      },
      //微信支付
      wechatPay() {
        this.commonPoint(this.pathId, this.productId, "ecPaymentMethod", 1);
        let that = this;
        let num = (this.produInfo.productPrice * 100).toFixed(0);
        axios({
          method: "POST",
          url: `${this.$single}/api/advert/wechatpay/h5PrePay`,
          data: {
            pathId: this.pathId,
            orderId: this.orderId,
            userPhone: this.userPhone,
            productId: this.productId,
            productName: this.produInfo.productName,
            price: num
          }
        }).then(res => {
          this.wxPolling();
          setTimeout(() => {
            that.showWxRes = true;
          }, 2500);
          setTimeout(() => {
            clearInterval(that.wxPoll);
          }, 180000);
          window.location.href = res.data;
        });
      },
      wxPolling() {
        this.wxPoll = setInterval(() => {
          this.wechatOpen(1, 0);
        }, 1000);
      },
      //打开获客链接 type=0,不下发短信;type=1,下发短信。showMsg=0,不展示信息，showMsg=1展示信息
      wechatOpen(type, showMsg) {
        const phone = this.userPhone || this.$store.state.userPhone;
        if (this.produInfo.productPrice > 0)  {
          axios({
            method: "POST",
            url: `${this.$single}/api/advert/launch/getWechatIndexClass`,
            data: {
              userPhone: phone,
              orderId: this.orderId
            }
          }).then(res => {
            if (res.data.code == 200) {
              clearInterval(this.wxPoll);
              let data = res.data.data;
              let path =
                data.wx_index +
                "?customer_channel=" +
                data.code +
                "_H5" +
                "_" +
                this.productId;
              if (type == 1) {
                this.custSms(data.code, data.wx_index, path);
              } else {
                this.openUrl(path);
              }
            } else {
              if (showMsg == 1) {
                this.$message({ message: "支付失败或未查到支付结果" });
              }
            }
          });
        } else {
          axios({
            method: "POST",
            url: `${this.$single}/api/advert/launch/getWechatLinkFree`,
            data: {
              userPhone: phone,
              pathId: this.pathId,
              productId: this.productId,
              orderId: this.orderId?this.orderId:''
            }
          }).then(res => {
            if (res.data.code == 200) {
              let data = res.data.data;
              let path =
                data.link_url +
                "?customer_channel=" +
                data.orderId +
                "_H5" +
                "_" +
                this.productId;
              this.openUrl(path);
            } else {
              this.$message({ message: res.data.msg });
            }
          });
        }
      },
      //下发客户短信
      custSms(orderId, userId, path) {
        axios({
          method: "POST",
          url: `${this.$backend}/customer_acquisition/send_signup_sms`,
          data: {
            order_code: orderId,
            wx_user_id: userId,
            prodcut_id: this.productId
          }
        }).then(res => {
          this.openUrl(path);
        });
      }
    }
  };
  </script>
  
  <style scoped>
  .question {
    background: #f2f2f2;
    height: 100vh;
  }
  .main {
    margin: -15px 12px 0;
    background: #fff;
    padding: 15px;
    border-radius: 15px;
    z-index: 2;
    position: relative;
    height: 75vh;
  }
  .main h5 {
    font-size: 16px;
    color: #333;
    margin: 10px 0;
  }
  .main .ques {
    margin-bottom: 25px;
  }
  .cbtn {
    margin-top: 25vh;
    padding: 10px 25px;
    background: linear-gradient(90deg, #ff4242 0%, #ff7e18 100%);
    text-align: center;
    border-radius: 30px;
  }
  .cbtn .text {
    color: #fff;
    font-size: 20px;
  }
  .mask {
    position: fixed;
    background: rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 9;
  }
  .bg-white {
    background: #fff;
    border-radius: 30px;
    padding: 30px;
    margin-top: 40vh;
    width: 160px;
    margin-left: calc(50vw - 105px);
    color: #ff6826;
    font-size: 16px;
    text-align: center;
  }
  .bg-white i {
    font-size: 28px;
    margin-bottom: 20px;
  }
  .panel {
    background: url(../../assets/images/retain.png) no-repeat;
    width: 100%;
    height: 82vw;
    background-size: cover;
    margin-top: 40%;
    position: relative;
  }
  .panel .df {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    justify-content: center;
  }
  .panel .btn {
    padding: 10px 20px;
    border-radius: 10px;
    margin: 20px 15px 40px;
    font-size: 20px;
    font-weight: bold;
  }
  .panel .left {
    color: #7d2500;
    border: 1px solid #7d2500;
  }
  .panel .right {
    color: #fff;
    background: linear-gradient(90deg, #ff0000 0%, #ff7200 100%);
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/product/questionNew.vue